import { IOffer } from '../../../types/offer';

export function isReadyBusiness(offer: IOffer): boolean {
  return Boolean(offer.readyBusinessType);
}
